//@flow
import {ThunkAction} from "redux-thunk";
import type {StockInformation} from "../event/model/stockInformation";
import dmsCommunicationService from "../service/dmsCommunicationService";
import CartService from "../../cart/service/CartService";
import type {DmsPart, DmsTask} from "../event/model/dmsOrders";
import {enhanceCartItems} from "../../cart/service/cartEnhancer";

export const DMS_ERROR = "DMS_ERROR";
export const DMS_ORDER_VEHICLE_MISMATCH = "DMS_ORDER_VEHICLE_MISMATCH";
export const DMS_ORDERS = {
	REQUEST: "DMS_ORDERS_REQUEST",
	FOUND: "DMS_ORDERS_FOUND",
	NOT_FOUND: "DMS_ORDERS_NOT_FOUND",
};

export const DMS_ORDER_GET_BY_ID = {
	REQUEST: "DMS_ORDER_GET_BY_ID_REQUEST",
	SUCCESS: "DMS_ORDER_GET_BY_ID_SUCCESS",
	NOT_FOUND: "DMS_ORDER_GET_BY_ID_NOT_FOUND",
	TIMEOUT: "DMS_ORDER_GET_BY_ID_TIMEOUT",
};

export const DMS_ORDER_GET_BY_ID_TIMEOUT_MS = 15000;

export const VEHICLE = {
	REQUEST: "CUSTOMERS_AND_VEHICLES_REQUEST",
	FOUND: "CUSTOMERS_AND_VEHICLES_FOUND",
	NOT_FOUND: "CUSTOMERS_AND_VEHICLES_NOT_FOUND",
};

export const STOCK_INFORMATION = {
	REQUEST: "STOCK_INFORMATION_REQUEST",
	FOUND: "STOCK_INFORMATION_FOUND",
	NOT_FOUND: "STOCK_INFORMATION_NOT_FOUND",
};

export const DMS_ORDER_ADD_PART = {
	REQUEST: "DMS_ORDER_ADD_PART_REQUEST",
	SUCCESS: "DMS_ORDER_ADD_PART_SUCCESS",
	ERROR: "DMS_ORDER_ADD_PART_ERROR",
};

export const DMS_ORDER_UPDATE_PART = {
	REQUEST: "DMS_ORDER_UPDATE_PART_REQUEST",
	SUCCESS: "DMS_ORDER_UPDATE_PART_SUCCESS",
	ERROR: "DMS_ORDER_UPDATE_PART_ERROR",
};

export const DMS_ORDER_ADD_PARTS = {
	REQUEST: "DMS_ORDER_ADD_PARTS_REQUEST",
	SUCCESS: "DMS_ORDER_ADD_PARTS_SUCCESS",
	ERROR: "DMS_ORDER_ADD_PARTS_ERROR",
};

export const DMS_ORDER_DELETE_PART = {
	REQUEST: "DMS_ORDER_DELETE_PART_REQUEST",
	SUCCESS: "DMS_ORDER_DELETE_PART_SUCCESS",
	ERROR: "DMS_ORDER_DELETE_PART_ERROR",
};

export const DMS_ORDER_ADD_TASKS = {
	REQUEST: "DMS_ORDER_ADD_TASKS_REQUEST",
	SUCCESS: "DMS_ORDER_ADD_TASKS_SUCCESS",
	ERROR: "DMS_ORDER_ADD_TASKS_ERROR",
};

export const DMS_ORDER_DELETE_TASK = {
	REQUEST: "DMS_ORDER_DELETE_TASK_REQUEST",
	SUCCESS: "DMS_ORDER_DELETE_TASK_SUCCESS",
	ERROR: "DMS_ORDER_DELETE_TASK_ERROR",
};

export const DMS_ORDER_UPDATE_TASK = {
	REQUEST: "DMS_ORDER_UPDATE_TASK_REQUEST",
	SUCCESS: "DMS_ORDER_UPDATE_TASK_SUCCESS",
	ERROR: "DMS_ORDER_UPDATE_TASK_ERROR",
};

export const DMS_ORDER_ADD_TASKS_WITH_SPARES = {
	REQUEST: "DMS_ORDER_ADD_TASKS_WITH_SPARES_REQUEST",
	SUCCESS: "DMS_ORDER_ADD_TASKS_WITH_SPARES_SUCCESS",
	ERROR: "DMS_ORDER_ADD_TASKS_WITH_SPARES_ERROR",
};

export const DMS_CONNECTION_PING = {
	REQUEST: "DMS_CONNECTION_PING_REQUEST",
	SUCCESS: "DMS_CONNECTION_PING_SUCCESS",
	ERROR: "DMS_CONNECTION_PING_ERROR",
};

export type StockInformationRequestAction = { type: typeof STOCK_INFORMATION.REQUEST }
export type StockInformationSuccessAction = { type: typeof STOCK_INFORMATION.FOUND, payload: StockInformation }
export type DmsErrorAction = { type: typeof DMS_ERROR }

export function failEventSource(error): ThunkAction {
	return {
		type: DMS_ERROR,
		error: error
	};
}

export const getVehicleByVin = (vin: string) => {
	return async dispatch => {
		dmsCommunicationService.getVehicleByVin(vin)
			.then(() => {
				return dispatch({type: VEHICLE.REQUEST});
			})
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};

export const searchVehicleByLicensePlate = (licensePlate: string) => {
	return async dispatch => {
		dmsCommunicationService.searchVehicleByLicensePlate(licensePlate)
			.then(() => {
				return dispatch({type: VEHICLE.REQUEST});
			})
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};

export const searchVehicleByCustomerName = (name: string) => {
	return async dispatch => {
		dmsCommunicationService.searchVehicleByCustomerName(name)
			.then(() => {
				return dispatch({type: VEHICLE.REQUEST});
			})
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};
export const searchVehicleByCustomerEmail = (email: string) => {
	return async dispatch => {
		dmsCommunicationService.searchVehicleByCustomerEmail(email)
			.then(() => {
				return dispatch({type: VEHICLE.REQUEST});
			})
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};
export const searchVehicleByCustomerPhone = (phone: string) => {
	return async dispatch => {
		dmsCommunicationService.searchVehicleByCustomerPhone(phone)
			.then(() => {
				return dispatch({type: VEHICLE.REQUEST});
			})
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};

export const getLocalStock = (partNumbers: number[]) => {
	return async dispatch => {
		dmsCommunicationService.getLocalStock(partNumbers)
			.then(() => {
				return dispatch({type: STOCK_INFORMATION.REQUEST});
			})
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};

export const getOrders = (customerNumber: string) => {
	return async dispatch => {
		dmsCommunicationService.getOrders(customerNumber)
			.then(() => {
				return dispatch({type: DMS_ORDERS.REQUEST});
			})
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};

let orderTimeout;
export const getOrderById = (orderId: string) => {
	return async (dispatch, getState) => {
		dispatch({type: DMS_ORDER_GET_BY_ID.REQUEST});
		clearTimeout(orderTimeout);
		orderTimeout = setTimeout(() => {
				if (getState().dmsOrders.isFetchingOrder) {
					dispatch({type: DMS_ORDER_GET_BY_ID.TIMEOUT});
				}
			},
			DMS_ORDER_GET_BY_ID_TIMEOUT_MS
		);
		dmsCommunicationService.getOrderById(orderId)
			.catch(e => {
				return dispatch({type: DMS_ERROR, error: e.message});
			});
	};
};

export const addWatchListItemsToOrder = (dmsOrderNumber, watchListName, lineItemId) => {
	return async dispatch => {
		try {
			const watchList = await CartService.getWatchList(watchListName, "WATCHLIST");
			const enhancedItems = await enhanceCartItems(watchList.cartItems, false);
			const items = enhancedItems.map(cartItem => {
				return {
					partNumber: cartItem.partNumber,
					quantity: cartItem.amount,
					unitPriceValue: cartItem.detail.storage.retailPrice.value
				};
			});
			await dmsCommunicationService.addPartsToOrder(dmsOrderNumber, items, lineItemId);
			return dispatch({type: DMS_ORDER_ADD_PARTS.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const addPartsToOrder = (dmsOrderNumber: string, parts: DmsPart[]) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.addPartsToOrder(dmsOrderNumber, parts);
			return dispatch({type: DMS_ORDER_ADD_PARTS.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const addPartToOrder = (dmsOrderNumber, partNumber, quantity) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.addPartToOrder(
				dmsOrderNumber,
				partNumber,
				quantity
			);
			return dispatch({type: DMS_ORDER_ADD_PART.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const updatePartFromOrder = (dmsOrderNumber, partNumber, quantity, unitPriceNetValue, lineItemId) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.updatePartFromOrder(
				dmsOrderNumber,
				partNumber,
				quantity,
				unitPriceNetValue,
				lineItemId
			);
			return dispatch({type: DMS_ORDER_UPDATE_PART.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const deletePartFromOrder = (dmsOrderNumber, partNumber, lineItemId) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.deletePartFromOrder(dmsOrderNumber, partNumber, lineItemId);
			return dispatch({type: DMS_ORDER_DELETE_PART.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const addTasksToOrder = (dmsOrderNumber: string, tasks: DmsTask[], lineItemId: string) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.addTasksToOrder(dmsOrderNumber, tasks, lineItemId);
			return dispatch({type: DMS_ORDER_ADD_TASKS.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const deleteTaskFromOrder = (dmsOrderNumber, taskNumber, lineItemId) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.deleteTaskFromOrder(dmsOrderNumber, taskNumber, lineItemId);
			return dispatch({type: DMS_ORDER_DELETE_TASK.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const updateTaskFromOrder = (dmsOrderNumber, task: DmsTask, lineItemId: string) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.updateTaskFromOrder(
				dmsOrderNumber,
				task,
				lineItemId
			);
			return dispatch({type: DMS_ORDER_UPDATE_TASK.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const addTasksWithParts = (dmsOrderNumber: string, tasks: DmsTask[], parts: DmsPart[], lineItemId: number) => {
	return async dispatch => {
		try {
			await dmsCommunicationService.addTasksWithPartsToOrder(dmsOrderNumber, tasks, parts, lineItemId);
			return dispatch({type: DMS_ORDER_ADD_TASKS_WITH_SPARES.REQUEST});
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};

export const pingDealerDmsWSConnections = () => {
	return async dispatch => {
		dispatch({type: DMS_CONNECTION_PING.REQUEST});
		try {
			await dmsCommunicationService.pingDealerWSConnections();
		} catch (e) {
			return dispatch({type: DMS_ERROR, error: e.message});
		}
	};
};
